import { PageHeader } from '../../components/PageHeader';
import { ServiciosTable } from './components/ServiciosTable';
import { useT } from '../../locales';

export function ServiciosListPage() {
  const t = useT();
  return (
    <div>
      <PageHeader title={t('pages.servicios.title')} subtitle={t('pages.servicios.subtitle')} />
      <ServiciosTable />
    </div>
  );
}
